const HEARTBEAT_INTERVAL_MS = 2 * 60 * 1000; // 2 minutes

async function sendHeartbeat(): Promise<void> {
  try {
    const baseUrl: string =
      window.__RHVKLSO002_CONFIG.LIFEPURCHASE_SERVICE_API_URL;
    const response = await fetch(`${baseUrl}/heartbeat`);

    if (!response.ok) {
      console.debug('Heartbeat request failed:', response.status);
    }
  } catch (error) {
    console.debug('Heartbeat request failed:', error);
  }
}

export function initializeHeartbeat(): void {
  setInterval(() => {
    void sendHeartbeat();
  }, HEARTBEAT_INTERVAL_MS);
}
